import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/AVTR1.jpg' 
import AVTR2 from '../../assets/AVTR2.jpg' 
import AVTR3 from '../../assets/AVTR3.jpg' 
import AVTR4 from '../../assets/AVTR4.jpg' 


// import Swiper core and required modules
import {Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const data = [
  {
    avatar: AVTR1,
    name: 'John Oliver',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa perferendis commodi delectus a nulla, quo fugit labore placeat reprehenderit possimus'
  },
  {
    avatar: AVTR2,
    name: 'Dorothy Michael',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa perferendis commodi delectus a nulla, quo fugit labore placeat reprehenderit possimus'
  },
  {
    avatar: AVTR3,
    name: 'Asif Khan',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa perferendis commodi delectus a nulla, quo fugit labore placeat reprehenderit possimus'
  },
  {
    avatar: AVTR4,
    name: 'Walter White',
    review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa perferendis commodi delectus a nulla, quo fugit labore placeat reprehenderit possimus'
  }
]


const testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container"
      // install Swiper modules
      modules={[Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      pagination={{ clickable: true }}>
        {
          data.map(({avatar, name, review}, index) =>{
            return(
                    <SwiperSlide key={index} className="testimonial">
                      <div className="client__avatar">
                        <img src={avatar}/>
                      </div>
                       <h5 className='client__name'>{name}</h5>
                       <small className='client__review'>{review}</small>
                    </SwiperSlide>
                 )
          })
        }
      </Swiper>
    </section>
  )
}

export default testimonials